import React from "react";
import CardSection from "../../../components/ui/CardSection";
import Icon from "../../../components/ui/Icon";
import { ISale } from "../../../classes/interfaces";
import { AddressRow, PickupNote } from "./DeliveryInfoSection.styles";

interface DeliveryInfoSectionProps {
  sale: ISale;
}

// Both branches of the original sale.deliveryType conditional are short, so this
// component owns the branch itself rather than requiring the parent to decide IF to
// mount it. Order/index.tsx always renders <DeliveryInfoSection sale={sale} />
// unconditionally.
export default function DeliveryInfoSection({ sale }: DeliveryInfoSectionProps) {
  if (sale.deliveryType === "delivery") {
    return (
      <CardSection icon="moto" title="Endereço de entrega">
        <AddressRow>
          <Icon name="pin" size={16} />
          {sale.deliveryAddress +
            ", " +
            sale.deliveryNumber +
            " - " +
            sale.deliveryDistrict +
            ", " +
            sale.deliveryZipCode +
            " - " +
            sale.deliveryCity?.name +
            "/" +
            sale.deliveryCity?.state || ""}
        </AddressRow>
      </CardSection>
    );
  }
  return (
    <CardSection icon="bag" title="Vou Buscar">
      <PickupNote>Retirada no estabelecimento.</PickupNote>
    </CardSection>
  );
}
